//@flow
export const colors =
[
	'#1abc9c',
	'#2ecc71',
	'#3498db',
	'#34495e',
	'#16a085',
	'#27ae60',
	'#2980b9',
	'#8e44ad',
	'#2c3e50',
	'#f1c40f',
	'#e67e22',
	'#e74c3c',
	'#f39c12',
	'#d35400',
	'#c0392b',
	'#7f8c8d'
];

export const getRandomColor = () => {
	const random = Math.floor(Math.random() * colors.length)
	return colors[random]
}



// WEBPACK FOOTER //
// ./src/constants/colors.js